module.exports = __webpack_public_path__ + "img/micoma_banner_pc.bf64633a.png";